export enum TrackingAssetType {
	TRANSLATE = 'TRANSLATE'
}